import { pick } from 'lodash-es';
import * as yup from 'yup';
import { RendererType } from '../../data-models/field-definition';
import { requiredMsg } from '../../pages/Finance/components/TransactionModal/Forms/utils/validationMessages';
import { BooleanFormatterId } from '../../util/formatters/BooleanFormatters';
import { getRoundLabel, isPrivateEquityClient } from '../../util/preference-utils';
import { currencyIdField, sharesField, usdField } from '../common-schema-defs';

export const TransactionsCommonSchemas = {
  base() {
    return {
      coInvestors: yup.array(),
      currencyid: currencyIdField(),
      fullyDilutedShares: sharesField(),
      fundId: yup.number().nullable().label('Fund').fieldMeta({
        renderer: RendererType.id,
        formatter: 'fund',
      }),
      familyId: yup.number().nullable().label('Fund Family'),
      investmentAmount: yup.number().fieldMeta({
        formatter: 'currency',
        renderer: RendererType.number,
      }),
      investmentRoundId: investmentRoundId(),
      stage: investmentStage(),
      leadInvestor: yup.string(),
      noOfShares: yup.number().fieldMeta({
        label: 'Shares Purchased',
        renderer: RendererType.number,
      }),
      notes: yup.string(),
      position: yup.string().label('Investment'),
      postMoneyValuation: yup.number(),
      pricePerShare: usdField(),
      security: yup.string(),
      status: yup.string(),
      transactionDate: yup.date().fieldMeta({
        renderer: RendererType.date,
      }),
      transactionTypeId: yup.number().label('Transaction Type').gridMeta({
        renderer: RendererType.id,
        formatter: 'transactionType',
      }),
      valuationImpact: yup.boolean().fieldMeta({
        renderer: RendererType.boolean,
        formatter: BooleanFormatterId.yesNo,
      }),
    };
  },
  gridFields() {
    const { investmentAmount, ...base } = this.base();

    return {
      ...base,
      transactionDate: base.transactionDate.gridMeta({
        width: 200,
      }),
    };
  },
  allTransactionsCommonFields() {
    const isPrivateEquity = isPrivateEquityClient();
    const fields = [
      'transactionDate',
      'fundId',
      'transactionTypeId',
      'investmentRoundId',
      'status',
      'notes',
      'id',
    ];
    if (!isPrivateEquity) {
      fields.splice(3, 0, 'stage');
    }
    return pick(TransactionsCommonSchemas.gridFields(), fields);
  },
};

export function requiredCurrencyIdField() {
  return currencyIdField().required(requiredMsg('Currency'));
}

/**
 * FIXME MAGGIE-7034 - Review if both this & requiredCurrencyIdField are needed.
 */
export function transactionCurrencyIdField() {
  return currencyIdField().nullable().required(requiredMsg('Currency'));
}

export function investmentRoundId(key = 'investmentRoundId', label?: string) {
  const investmentRoundLabel = label ?? getRoundLabel();
  return yup.number().fieldMeta({
    label: investmentRoundLabel,
    key,
    formatter: 'investmentRound',
    renderer: RendererType.id,
  });
}

export function investmentStage() {
  return yup.string().customMeta({
    label: 'Stage',
    formatter: 'stage',
    renderer: RendererType.id,
  });
}
